import { deepmerge } from "@mui/utils";
import { createTheme } from "@mui/material/styles";

import "./muiScopedCssBaseline.css";
import "./miscOverrides.css";
import "./basicColors.css";
import "./scrollbar.css";

const exports = {
    set: (isDarkMode, disableAnimation) => {
        let baseTheme = createTheme({
            palette: {
                mode: isDarkMode ? "dark" : "light",
                background: {
                    paper: isDarkMode ? "#272b30" : "#ffffff",
                },
                primary: {
                    main: "#4594ad",
                    contrastText: "#fff",
                },
                secondary: {
                    main: "#ee5f5b",
                    contrastText: "#fff",
                },
                error: {
                    main: "#ee5f5b",
                    contrastText: "#fff",
                },
                warning: {
                    main: "#f89406",
                    contrastText: "#fff",
                },
                info: {
                    main: "#5bc0de",
                    contrastText: "#fff",
                },
                success: {
                    main: "#62c462",
                    contrastText: "#fff",
                },
                customGray: {
                    main: isDarkMode ? "rgba(81, 81, 81, 1)" : "rgba(224, 224, 224, 1)",
                    contrastText: "#fff",
                },
                customLink: {
                    main: isDarkMode ? "#9fcbd9" : "#4594AD",
                },
            },
        });

        baseTheme = createTheme(deepmerge(baseTheme, {
            components: {
                MuiDisabled: {

                },
                MuiButton: {
                    defaultProps: {
                        size: "medium",
                    },
                    styleOverrides: {
                        root: {
                            minWidth: "initial",
                            fontSize: 12,
                            padding: "3px 8px",
                            textTransform: "none",
                        },
                        textSizeSmall: {
                            fontSize: 12,
                            padding: "2px 4px",
                        },
                        containedSizeSmall: {
                            fontSize: 12,
                            padding: "2px 4px",
                        },
                        outlinedSizeSmall: {
                            fontSize: 12,
                            padding: "2px 4px",
                        },
                    },
                },
                MuiGrid: {
                    styleOverrides: {
                        item: {
                            padding: 2,
                        },
                    },
                },
                // MuiFilledInput: {
                //     defaultProps: {
                //         margin: "dense",
                //     },
                //     styleOverrides: {
                //         inputMarginDense: {
                //             paddingTop: 21,
                //             paddingBottom: 3,
                //             paddingLeft: 7,
                //         },
                //     },
                // },
                // MuiFormControl: {
                //     defaultProps: {
                //         margin: "dense",
                //     },
                //     styleOverrides: {
                //         marginDense: {
                //             marginTop: 2,
                //             // paddingLeft: 2,
                //             // paddingRight: 2,
                //         },
                //     },
                // },
                MuiFormHelperText: {
                    defaultProps: {
                        margin: "dense",
                    },
                    styleOverrides: {
                        marginDense: {
                            marginTop: 0,
                        },
                        contained: {
                            marginLeft: 7,
                        },
                    },
                },
                MuiIconButton: {
                    defaultProps: {
                        size: "small",
                    },
                    styleOverrides: {
                        sizeSmall: {
                            // Adjust spacing to reach minimal touch target hitbox
                            marginLeft: 0,
                            marginRight: 0,
                            padding: 3,
                        },
                    },
                },
                MuiAlert: {
                    styleOverrides: {
                        // root: {
                        //     height: 30,
                        //     width: 30,
                        //     fontSize: 24,
                        // },
                        root: {
                            fontSize: 12,
                            padding: 4,
                        },
                        message: {
                            padding: "8px 0 0 0",
                        },
                    },
                },
                MuiInputBase: {
                    defaultProps: {
                        margin: "dense",
                    },
                    styleOverrides: {
                        root: {
                            fontSize: 12,
                            paddingTop: 0,
                            paddingBottom: 0,
                            margin: 2,
                            backgroundColor: isDarkMode ? "#2e3438" : "#ffffff",
                        },
                        input: {
                            paddingBottom: 3,
                            height: 15,
                        },
                        inputMarginDense: {
                            paddingTop: 4,
                        },
                    },
                },
                MuiButtonBase: {
                    defaultProps: {
                        disableRipple: disableAnimation,
                        disableTouchRipple: disableAnimation,
                    },
                    styleOverrides: {
                        root: {
                            textTransform: "none",
                        },
                    },
                },
                MuiInputLabel: {
                    defaultProps: {
                        margin: "dense",
                        shrink: true,
                    },
                    styleOverrides: {
                        root: {
                            color: baseTheme.palette.text.primary,
                            "-webkit-text-fill-color": "initial",
                            fontSize: 12,
                        },
                    },
                },
                MuiListItem: {
                    defaultProps: {
                        dense: true,
                    },
                    styleOverrides: {
                        gutters: {
                            paddingLeft: 8,
                            paddingRight: 8,
                        },
                        dense: {
                            paddingTop: 0,
                            paddingBottom: 0,
                            margin: 0,
                        },
                    },
                },
                MuiListItemText: {
                    styleOverrides: {
                        root: {
                            marginTop: 2,
                            marginBottom: 2,
                        },
                    },
                },
                MuiListItemAvatar: {
                    styleOverrides: {
                        root: {
                            minWidth: 38,
                        },
                    },
                },
                // MuiOutlinedInput: {
                //     styleOverrides: {
                //         root: {
                //             margin: 0,
                //             paddingTop: 0,
                //             paddingBottom: 0,
                //             paddingLeft: 0,
                //             paddingRight: 0,
                //         },
                //         input: {
                //             paddingTop: 3,
                //             paddingBottom: 3,
                //             paddingLeft: 3,
                //             paddingRight: 3,
                //         },
                //     },
                // },
                MuiFab: {
                    defaultProps: {
                        size: "small",
                    },
                },
                MuiTable: {
                    defaultProps: {
                        size: "small",
                    },
                },
                // MuiTextField: {
                //     defaultProps: {
                //         margin: "dense",
                //     },
                //     styleOverrides: {
                //         root: {
                //             margin: 2,
                //             width: "calc(100% - 4px)!important",
                //         },
                //     },
                // },
                MuiToolbar: {
                    defaultProps: {
                        variant: "dense",
                    },
                    styleOverrides: {
                        dense: {
                            minHeight: 25,
                            padding: 0,
                            whiteSpace: "nowrap",
                        },
                    },
                },
                MuiMenuItem: {
                    styleOverrides: {
                        root: {
                            margin: 2,
                            fontSize: "12px",
                        },
                    },
                },
                MuiTooltip: {
                    styleOverrides: {
                        tooltip: {
                            fontSize: 12,
                        },
                    },
                },
                // MuiSelect: {
                //     styleOverrides: {
                //         root: {
                //             paddingTop: 2,
                //         },
                //     },
                // },
                MuiTableCell: {
                    styleOverrides: {
                        sizeSmall: {
                            padding: "1px 2px",
                            fontSize: "12px",
                        },
                        root: {
                            verticalAlign: "top",
                        },
                    },
                },
                MuiTablePagination: {
                    styleOverrides: {
                        root: {
                            overflow: "initial",
                        },
                        toolbar: {
                            minHeight: "initial!important",
                            height: 20,
                        },
                        spacer: {
                            flex: "initial",
                        },
                        displayedRows: {
                            margin: 0,
                            paddingTop: 1,
                            fontSize: 12,
                        },
                    },
                },
                MuiPopover: {
                    styleOverrides: {
                        root: {
                            zIndex: "1200!important",
                        },
                    },
                },
                MuiTypography: {
                    styleOverrides: {
                        h1: { fontSize: 30 },
                        h2: { fontSize: 24 },
                        h3: { fontSize: 20 },
                        h4: { fontSize: 16 },
                        h5: { fontSize: 14 },
                        h6: { fontSize: 12 },
                        subtitle1: { fontSize: 12 },
                        subtitle2: { fontSize: 12 },
                        body1: { fontSize: 12 },
                        body2: { fontSize: 12 },
                        button: { fontSize: 12 },
                        caption: { fontSize: 12 },
                        overline: { fontSize: 12 },
                        gutterBottom: { fontSize: "none" },
                    },
                },
                MuiDialogTitle: {
                    styleOverrides: {
                        root: {
                            padding: 8,
                        },
                    },
                },
                MuiDialogContent: {
                    styleOverrides: {
                        root: {
                            fontSize: 12,
                            padding: 8,
                        },
                        dividers: {
                            fontSize: 12,
                            padding: 8,
                        },
                    },
                },
                MuiTabs: {
                    styleOverrides: {
                        root: {
                            minHeight: "inherit",
                            height: 30,
                        },
                    },
                },
                MuiTab: {
                    styleOverrides: {
                        root: {
                            minHeight: "inherit",
                            height: 30,
                            padding: "0 6px",
                            fontSize: 12,
                        },
                    },
                },
                MuiAppBar: {
                    styleOverrides: {
                        root: {
                            backgroundColor: "#4594ad",
                        },
                    },
                },
                MuiSwitch: {
                    styleOverrides: {
                        switchBase: {
                            // TODO: bitte auslagern, hier durch wurde die Standard color Eigenschaft vom Switch deaktiviert, evtl. eigene Componente erstellen
                            // color: "green",
                            // opacity: "0.6",
                        },
                        colorSecondary: {
                            "&$checked": {
                                // color: "red",
                                // opacity: "0.6",
                            },
                        },
                        track: {
                            // backgroundColor: "green",
                            // "$checked$checked + &": {
                            //     backgroundColor: "red",
                            // },
                        },
                    },
                },
                MuiScopedCssBaseline: {
                    styleOverrides: {
                        "@global": {
                            ".MuiTablePagination-actions .MuiButtonBase-root": {
                                padding: "0 2px",
                            },
                            ".MuiTabScrollButton-root .MuiSvgIcon-root": {
                                fontSize: 24,
                            },
                            ".MuiAppBar-colorPrimary": {
                                backgroundColor: "#4594ad",
                            },
                            ".MuiAppBar-colorDefault": {
                                backgroundColor: isDarkMode ? "#424242!important" : "#f5f5f5!important",
                            },
                            // '.MuiToolbar-root:not(:first-of-type) .MuiButtonBase-root':{
                            //   marginLeft:5,
                            //   marginRight: 5
                            // },
                            ".MuiIconButton-sizeSmall .MuiSvgIcon-root": {
                                width: 16,
                                height: 16,
                            },
                            ".MuiToolbar-dense .MuiTypography-root": {
                                fontSize: 12,
                                paddingTop: 3,
                            },
                            // ".MuiInputLabel-marginDense": {
                            //     transform: "translate(0, 18px) scale(1)!important",
                            // },
                            // ".MuiInputLabel-shrink": {
                            //     transform: "translate(0, 1.5px) scale(0.75)!important",
                            // },
                            // ".MuiInputLabel-outlined.MuiInputLabel-marginDense": {
                            //     transform: "translate(7px, 8px) scale(1)!important",
                            // },
                            // ".MuiInputLabel-outlined.MuiInputLabel-shrink": {
                            //     transform: "translate(14px, -6px) scale(0.75)!important",
                            // },
                            // ".MuiInputLabel-filled.MuiInputLabel-marginDense": {
                            //     transform: "translate(7px, 17px) scale(1)!important",
                            // },
                            // ".MuiInputLabel-filled.MuiInputLabel-shrink.MuiInputLabel-marginDense": {
                            //     transform: "translate(12px, 7px) scale(0.75)!important",
                            // },
                            ".MuiListItemSecondaryAction-root .MuiButton-outlined": {
                                fontSize: 20,
                            },
                            ".MuiTableCell-root .MuiListItem-root": {
                                paddingLeft: 0,
                                paddingRight: 0,
                            },
                            ".MuiTableCell-root .MuiListItem-root .MuiListItemText-root": {
                                marginTop: 0,
                                marginBottom: 0,
                            },
                            // ".TextField-noMargin": {
                            //     margin: 0,
                            // },
                            // ".TextField-noMargin *": {
                            //     margin: 0,
                            // },
                        },
                    },
                },
            },
            zIndex: {
                mobileStepper: 500,
                speedDial: 650,
                appBar: 700,
                drawer: 800,
                modal: 900,
                snackbar: 1200,
                tooltip: 2000,
            },
            overrides: {
                MuiTabScrollButton: {
                    root: {
                        width: 25,
                    },
                },
                MuiCssBaseline: {

                },
            },
            typography: {
                // In Chinese and Japanese the characters are usually larger,
                // so a smaller fontsize may be appropriate.
                fontSize: 12,
            },
            spacing: 2,
            transitions: disableAnimation ? {
                create: () => "none",
            } : undefined,
        }));

        const miscTheme = {
            sidebar: {
                width: 255,
                widthCollapsed: baseTheme.spacing(7),
                background: "#4a4d5a;",
                color: "#fff",
            },
        };
        return { ...baseTheme, ...miscTheme };
    },
};

export default exports;
